import { Component, HostListener, OnInit } from '@angular/core';
import { label } from 'src/app/constants/labels';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
import { BaseAPIService } from 'src/app/shared/services/api.base.service';
import { environment } from 'src/environments/env-proxy';
import { ToastrService } from 'ngx-toastr';
import { DataService } from 'src/app/shared/services/data.service';
import { saveAs } from 'file-saver';
import { MatDialog } from '@angular/material/dialog';
import { DefaultApp } from 'src/app/models/defaultApp';

@Component({
  selector: 'app-migration-expert',
  templateUrl: './sp-migration-expert.component.html',
  styleUrls: ['./sp-migration-expert.component.scss']
})
export class MigrationExpertComponent implements OnInit {
  labels;
  AppName: string;
  isAdmin = null;
  serverUrl = environment.serverUrl;
  loading: boolean;
  appId: number;
  defaultApp: string;
  defaultAppName: string;
  buttonText: string;
  appInfo;
  downloading: boolean;
  warningPopup = false;
  appFileDetails: DefaultApp[];
  fileId: number;
  toasterTimeOut: number = environment.toasterTimeOut;

  constructor(private readonly authenticationService: AuthenticationService, private readonly baseService: BaseAPIService, private readonly toastr: ToastrService,
  private readonly dataService: DataService, public dialog: MatDialog) { }
 /**
   * Footer Page initialization
   * Creates footer component
   */ 
  ngOnInit() {
    this.labels = label;
    this.isAdmin = this.authenticationService.adminRole;
    this.dataService.getNewAppInfo().subscribe(info => {
      this.appInfo = info;
    })
    if (sessionStorage.getItem('appInfo')) {
      this.appInfo = JSON.parse(sessionStorage.getItem('appInfo'));
      sessionStorage.removeItem('appInfo');
    }
    this.AppName = this.appInfo.name;
    this.appId = this.appInfo.appId;
    this.getDefaultApp();
  }
   /*
    * Function to set Application info and  removes old info
    * 
  */
  @HostListener('window:beforeunload', ['$event'])
      unloadNotification(_$event) {
        sessionStorage.removeItem('appInfo');
        sessionStorage.setItem('appInfo', JSON.stringify(this.appInfo));
      }
  
    /**
   * get Default Application info
   * returns the Default application details
   */ 
    getDefaultApp() {
    this.loading = true;
    this.baseService.GET(`${this.serverUrl}/api/File/GetDefaultFileDetailsByApplicationId/${this.appId}`).subscribe((appInfo : DefaultApp[]) => {
      if (appInfo.length === 0) {
        this.defaultApp = '';
        this.defaultAppName = '';
        this.loading = false;
      } else {
        this.appFileDetails=appInfo;
        this.buttonText = 'Download';
        this.defaultApp = this.appFileDetails[1].fileName;
        this.fileId = this.appFileDetails[1].fileId;
        this.loading = false;
        this.defaultAppName = this.defaultApp;
        const num = 25;
        if (this.defaultApp.length > num) {
          this.loading = false;
          this.defaultAppName = this.defaultApp.substring(0, num) + '...';
        }
      }
    }, 
    /* istanbul ignore next */
    (error) => {
      if (error) {
        this.loading = false;
        this.toastr.error(label.errorgetDefaultFile, '', {
          timeOut: this.toasterTimeOut
        });
      }
    });
  }

  /**
   * Gets download default EXE  
   * returns exe file of application
   */ 
  downloadEXE(){
    this.showAlert();
    const url= `${this.serverUrl}/api/File/DownloadFileByApplicationId/${this.appId}/${this.fileId}`;
    this.loading = true;
    this.downloading = true;
     this.baseService.DOWNLOADGet(url).subscribe(result => {
       /* istanbul ignore next */
      const blob = new Blob([result], { type: "application/octet-stream" });
      saveAs(blob, this.defaultApp);
      this.loading =false;
      this.downloading = false;
    },(_error) => {
        this.loading = false;
        this.toastr.error(label.errorDownloadtryagain, '', {
          timeOut: this.toasterTimeOut
        });
    });
  }

  userSelectionChanged(){
    this.fileId=(this.appFileDetails.filter(x=>x.fileName===this.defaultApp))[0].fileId;
  }

  showAlert(){
    this.warningPopup = true;
    setTimeout(() =>{
      this.warningPopup = false;
    }, this.toasterTimeOut)
  }

  close(){
    this.warningPopup = false;
  }
}

